// extracted by mini-css-extract-plugin
export var anchor = "AutolinkHeader-module--anchor--1a951";
export var cdsAssistiveText = "AutolinkHeader-module--cds--assistive-text--4af88";
export var cdsHideFeedback = "AutolinkHeader-module--cds--hide-feedback--0ec26";
export var cdsShowFeedback = "AutolinkHeader-module--cds--show-feedback--63170";
export var cdsSkeleton = "AutolinkHeader-module--cds--skeleton--1b41b";
export var cdsVisuallyHidden = "AutolinkHeader-module--cds--visually-hidden--25b8f";
export var header = "AutolinkHeader-module--header--888d5";
export var leftAnchor = "AutolinkHeader-module--left-anchor--07711";
export var rightAnchor = "AutolinkHeader-module--right-anchor--73c2a";